import request from './request'

export function listMaintenancePlan(data) {
  return request.post('/mes/maintenance-plans/list', data)
}
export function getMaintenancePlan(id) {
  return request.get('/mes/maintenance-plans/' + id)
}
export function saveMaintenancePlan(data) {
  return request.post('/mes/maintenance-plans', data)
}
export function updateMaintenancePlan(data) {
  return request.post('/mes/maintenance-plans/update', data)
}
export function deleteMaintenancePlan(ids) {
  return request.post('/mes/maintenance-plans/delete', ids)
}
export function generateMaintenancePlan(planId, force) {
  return request.post('/mes/maintenance-plans/generate/' + planId + '?force=' + (force ? 'true' : 'false'))
}
export function generateDueMaintenancePlans() {
  return request.post('/mes/maintenance-plans/generate-due', {})
}
